import { DataLayer } from '@piwikpro/react-piwik-pro';

import fetch from 'node-fetch';

import { LeadGenerationRequestBody } from '@mewa/types';

export const sendFormToBackend = async (data: LeadGenerationRequestBody) => {
  const url = process.env['GATSBY_SEND_FORMS_URL'];

  if (url !== undefined) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.ok) {
        console.info('[INFO] send-forms: Sent request:', data);
      } else {
        const message = '[ERROR] send-forms: Error while sending request.';
        console.error(message);

        DataLayer.push({
          event: `form_submit_error`,
        });

        throw new Error(message);
      }
    });
  } else {
    const message =
      '[ERROR] send-forms: Request not sent because no url is given.';
    console.error(message);
    return Promise.reject(message);
  }
};
